(() => {
  'use strict';

  const isConvertCartUrl = (value) => /(?:^|\/\/)(?:[^/]+\.)?convertcart\.com(?:\/|$)/i.test(String(value));
  const blockedSource = 'data:text/javascript,void%200';
  const sourceDescriptor = Object.getOwnPropertyDescriptor(HTMLScriptElement.prototype, 'src');

  if (sourceDescriptor && sourceDescriptor.get && sourceDescriptor.set) {
    Object.defineProperty(HTMLScriptElement.prototype, 'src', {
      get: sourceDescriptor.get,
      set(value) {
        sourceDescriptor.set.call(this, isConvertCartUrl(value) ? blockedSource : value);
      },
      configurable: true,
      enumerable: sourceDescriptor.enumerable
    });
  }

  const nativeSetAttribute = Element.prototype.setAttribute;
  Object.defineProperty(HTMLScriptElement.prototype, 'setAttribute', {
    value(name, value) {
      const nextValue = String(name).toLowerCase() === 'src' && isConvertCartUrl(value)
        ? blockedSource
        : value;
      return nativeSetAttribute.call(this, name, nextValue);
    },
    configurable: true,
    writable: true
  });
})();
